import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Stack,
  Typography,
} from '@mui/material';
import { CreditCard as CreditCardIcon, Business as BusinessIcon } from '@mui/icons-material';
import { AppButton } from '../design-system';

export type SubscriptionBillingType = 'stripe' | 'enterprise';

interface SubscriptionTypeChooserDialogProps {
  open: boolean;
  onClose: () => void;
  onSelect: (type: SubscriptionBillingType) => void;
}

const SubscriptionTypeChooserDialog: React.FC<SubscriptionTypeChooserDialogProps> = ({
  open,
  onClose,
  onSelect,
}) => (
  <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
    <DialogTitle>Add subscription</DialogTitle>
    <DialogContent>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Choose how this tenant will be billed. Stripe subscriptions use self-serve products;
        enterprise subscriptions use a pre-defined package from Products &amp; Pricing.
      </Typography>
      <Stack spacing={1.5}>
        <AppButton
          variant="outlined"
          fullWidth
          startIcon={<CreditCardIcon />}
          onClick={() => onSelect('stripe')}
          sx={{ justifyContent: 'flex-start', py: 1.5 }}
        >
          Stripe subscription
        </AppButton>
        <AppButton
          variant="outlined"
          fullWidth
          startIcon={<BusinessIcon />}
          onClick={() => onSelect('enterprise')}
          sx={{ justifyContent: 'flex-start', py: 1.5 }}
        >
          Enterprise package
        </AppButton>
      </Stack>
    </DialogContent>
    <DialogActions>
      <AppButton onClick={onClose}>Cancel</AppButton>
    </DialogActions>
  </Dialog>
);

export default SubscriptionTypeChooserDialog;
